import { SET_ALL_LANGUAGES_LIST } from "../../common/constants/ActionTypes"

const initialState = { 
    errorMessage: "",
    allLanguagesList: [],
}

export default function manageLanguagesReducer(state = initialState, action) {
    switch(action.type) {
        case SET_ALL_LANGUAGES_LIST: 
            return {
                ...state,
                allLanguagesList : action.payload
            }
        
        default:
            return state;
    }
}